// eslint-disable-next-line no-promise-executor-return
export default (delay) => new Promise((resolve) => setTimeout(resolve, delay));
